import { isStringNullOrWhiteSpace } from 'owa-localize';
import isMenuActionSupported from '../../utils/isMenuActionSupported';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { AttachmentFullViewState, AttachmentMenuAction } from 'owa-attachment-full-data';
import { getOpenInNewTabContextMenuItem } from 'owa-attachment-link-common';
import { ReferenceAttachmentModel } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import getAttachmentFileType from 'owa-attachment-model-store/lib/utils/getAttachmentFileType';

export default function openInNewTabContextMenuItemBuilder(
    attachment: AttachmentFullViewState,
    providerType: string
): IContextualMenuItem {
    const attachmentModel = getAttachment(attachment.attachmentId);

    if (
        !isMenuActionSupported(AttachmentMenuAction.OpenInNewTab, attachment) ||
        !attachment.strategy.isOpeningInProviderSupported ||
        !attachmentModel ||
        isStringNullOrWhiteSpace((<ReferenceAttachmentModel>attachmentModel).openUrl)
    ) {
        return null;
    }

    const fileType = getAttachmentFileType(attachmentModel);

    return getOpenInNewTabContextMenuItem(
        (<ReferenceAttachmentModel>attachmentModel).openUrl,
        () => {
            logUsage(
                'OpenInNewTab',
                {
                    providerType,
                    entryPoint: 'ContextMenu',
                },
                {
                    cosmosOnlyData: JSON.stringify({
                        fileType,
                        attachmentId: attachmentModel.model.AttachmentId?.Id,
                    }),
                }
            );
        }
    );
}
